import React from 'react';

import AemEditableText from '@/components/Aem/AemEditableText/AemEditableText';
import {AppButton} from '@/components/Button';
import appConfig from '@/config/appConfig.typed';
import {AUTO_DELIVERY_CHANGE_ADDRESS_BUTTON_ARIA_LABEL} from '@/consts/localization/localizationKeys';
import routePaths from '@/consts/route/routePaths';
import useConfigExternalLink from '@/hooks/externalLink/useConfigExternalLink';
import useIsDesktopLayout from '@/hooks/layout/useIsDesktopLayout';
import {getAriaLabel} from '@/services/accessibilityService';

const AutoDeliveryEditAddressButton = () => {
    const isDesktopLayout = useIsDesktopLayout();
    const autoDeliveryEditAddressExternalLink = appConfig.getAutoDeliveryEditAddressExternalLink();
    const {redirectToExternalLink} = useConfigExternalLink(autoDeliveryEditAddressExternalLink);

    if (!redirectToExternalLink) return;

    return (
        <AppButton
            className='shrink-0 border-primary-dark-85 text-16 font-bold md:text-14 md:font-normal'
            onClick={redirectToExternalLink}
            tertiary={isDesktopLayout}
            raw={!isDesktopLayout}
            aria-label={getAriaLabel(AUTO_DELIVERY_CHANGE_ADDRESS_BUTTON_ARIA_LABEL)}
        >
            <AemEditableText pageName={routePaths.AUTO_DELIVERY} itemName='changeAddressButton' />
        </AppButton>
    );
};

export default AutoDeliveryEditAddressButton;
